module.exports = __webpack_public_path__ + "static/media/study220728.e3d09a63.png";